import { useWeb3React } from '@web3-react/core'
import { isWalletConnectedKey } from 'constants/index'
import React from 'react'
import { Navigate } from 'react-router-dom'
import { useIsAdmin, useIsUserSignedIn } from 'state/user/hooks'

type Props = {
  roles?: string[]
  children: React.ReactNode
}

const ProtectedCuratorRoute: React.FC<Props> = ({ roles, children }) => {
  const { active, account } = useWeb3React()
  const isUserSigned = useIsUserSignedIn()
  const isAdmin = useIsAdmin(roles)
  const isConnected = localStorage.getItem(isWalletConnectedKey)

  if ((isConnected && !active) || !account) {
    // TODO: Replace with proper loading screen
    return <div>Loading...</div>
  }

  if (!isUserSigned || !isAdmin) {
    return <Navigate to="/curators/login" replace />
  }

  return <>{children}</>
}

export default ProtectedCuratorRoute
